import { Icon } from "@iconify/react/dist/iconify.js";
import { useEffect, useState } from "react";
import { httpConfig } from "./httpConfig";
import { RequestFetch } from "./config/requestFetch";
import liff from "@line/liff";
import Swal from "sweetalert2";

const RegisterNotification = () => {
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const [isnull, setIsnull] = useState(false);
  const [statusLogin, setStatusLogin] = useState(false);
  const [linePicture, setLinePicture] = useState(null);
  const [linename, setLinename] = useState(null);
  const [lineuserId, setLineuserId] = useState(null);
  const [registerStutas, setRegisterStutas] = useState(false);
  const http = httpConfig();

  const getIddoc = (id) => {
    return document.getElementById(id);
  };

  const handlecheckidpass = () => {
    if (username === null || password === null || !username || !password) {
      console.log("ยังไม่ได้กรอกข้อมูล username password");
      setIsnull(true);
      if (!username) {
        getIddoc("inputlogin-username").classList.add("inputlogin-red");
        getIddoc("inputlogin-username").style.border = "3px solid #e51c23";
        getIddoc("inputlogin-username").classList.add("handleerrorInputnull");
        setTimeout(() => {
          getIddoc("inputlogin-username").classList.remove(
            "handleerrorInputnull"
          );
        }, 400);
      } else {
        getIddoc("inputlogin-username").style.border = "3px solid #dedede";
        getIddoc("inputerrorshow-username").style.display = "none";
      }

      if (!password) {
        getIddoc("inputlogin-password").classList.add("inputlogin-red");
        getIddoc("inputlogin-password").style.border = "3px solid #e51c23";
        getIddoc("inputlogin-password").classList.add("handleerrorInputnull");
        setTimeout(() => {
          getIddoc("inputlogin-password").classList.remove(
            "handleerrorInputnull"
          );
        }, 400);
      } else {
        getIddoc("inputlogin-username").classList.remove("inputlogin-red");
        getIddoc("inputlogin-password").classList.remove("inputlogin-red");
        getIddoc("inputlogin-password").style.border = "3px solid #dedede";
        getIddoc("inputerrorshow-password").style.display = "none";
      }
    } else {
      setIsnull(false);
      getIddoc("inputlogin-username").style.border = "3px solid #dedede";
      getIddoc("inputlogin-password").style.border = "3px solid #dedede";
      getIddoc("inputerrorshow-username").style.display = "none";
      getIddoc("inputerrorshow-password").style.display = "none";
      handlefetchcheckusernamepassword(username, password);
    }
  };

  const handleNodatasomethingwrong = () => {
    getIddoc("inputlogin-username").style.border = "3px solid #e51c23";
    getIddoc("inputlogin-username").classList.add("handleerrorInputnull");
    getIddoc("inputlogin-password").style.border = "3px solid #e51c23";
    getIddoc("inputlogin-password").classList.add("handleerrorInputnull");
    getIddoc("inputerrorshow-username").style.display = "block";
    getIddoc("inputerrorshow-password").style.display = "block";
    setTimeout(() => {
      getIddoc("inputlogin-username").classList.remove("handleerrorInputnull");
      getIddoc("inputlogin-password").classList.remove("handleerrorInputnull");
    }, 400);
  };

  const handlefetchcheckusernamepassword = (id, pass) => {
    fetch(
      `${http}/loginform`,
      RequestFetch("POST", { id: id, pass: pass })
    ).then((res) => {
      if (res.ok) {
        res.json().then((result) => {
          console.log(result);
          if (result.message_status) {
            if (result.data[0]) {
              if (result.data.length === 1) {
                console.log("ดูสิว่ามีอะไรมาบ้าง", result.data[0]);
                if (result.data[0].line_grp) {
                  if (result.data[0].line_grp === lineuserId) {
                    console.log("อันนี้ตรงกันแล้ว");
                    Swal.fire({
                      iconHtml:
                        '<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 1024 1024"><path fill="#b2e1bb" d="M512 64a448 448 0 1 1 0 896a448 448 0 0 1 0-896m-55.808 536.384l-99.52-99.584a38.4 38.4 0 1 0-54.336 54.336l126.72 126.72a38.27 38.27 0 0 0 54.336 0l262.4-262.464a38.4 38.4 0 1 0-54.272-54.336z"/></svg>',
                      text: "ท่านได้ทำการลงทะเบียนไว้เรียบร้อยแล้ว!!!!",
                      showConfirmButton: false,
                      showCancelButton: false,
                      timer: 1800,
                      background: "#6a9588",
                      color: "#fefefe",
                      customClass: {
                        icon: "no-border-sweetalerticon",
                      },
                    });
                    setUsername(null);
                    setPassword(null);
                    getIddoc("inputlogin-username").value = "";
                    getIddoc("inputlogin-password").value = "";
                  } else {
                    // console.log("รายการ advisorId", result.data[0].Id);
                    // console.log("รายการ LINEUserId", lineuserId);
                    handleRegisterLineNotify(lineuserId, result.data[0].Id);
                  }
                } else {
                  handleRegisterLineNotify(lineuserId, result.data[0].Id);
                }
              }
            }
          } else {
            handleNodatasomethingwrong();
          }
        });
      }
    });
  };

  const handleRegisterLineNotify = (Iduserline, Idadvisor) => {
    let objectfetch = {
      lineuserId: Iduserline,
      advisorId: Idadvisor,
    };
    console.log("objectfetch", objectfetch);
    try {
      fetch(
        `${http}/registerLineNotify`,
        RequestFetch("POST", objectfetch)
      ).then((res) => {
        console.log("ทำไมกัน อะไรอะ ===>", res);
        if (res.ok) {
          res.json().then((data) => {
            if (data.status) {
              console.log(data.message);
              Swal.fire({
                title: "สมัครรับแจ้งเตือน !!!",
                text: "สำเร็จ !!!",
                showConfirmButton: false,
                showCancelButton: false,
                timer: 1800,
              });
              setRegisterStutas(true);
            }
            sessionStorage.setItem("lineRegisStatus", true);
          });
        }
      });
    } catch (error) {
      console.error("fail to fetch RegisterLineNotify !!!!", error);
    }
  };

  const handleTestSendMessageNotify = () => {
    try {
      let objectLineRequest = {
        userIdline: lineuserId,
        messageline: "ทดสอบการส่งข้อความแบบ flex messages !!!",
        linksendline: "http://localhost:3000/estiamte",
        tokenline:
          "a1WgRpp1JcYxXzRvvIgFb1GRBwfsx1aWRO2jBjnAF+8ZkR5+bChmQ1+1sy4algb7EHqklOJyaReHBbHGyzC92sZ4WQJNz/Bg2Nzyu9QpFFu1JQ+QoNQMoBISvZykmw5XJ/bKoxnG/u43XzHIpKnUiQdB04t89/1O/w1cDnyilFU=",
      };
      fetch(
        `${http}/sendmessageLINEoa`,
        RequestFetch("POST", objectLineRequest)
      ).then((res) => {
        if (res.ok) {
          console.log("message LINE is send !!!");
        }
      });
    } catch (error) {}
  };

  useEffect(() => {
    liff
      .init({ liffId: "2006392797-ZlwPLyqL" })
      .then(() => {
        if (!liff.isLoggedIn()) {
          liff.login();
        } else {
          setStatusLogin(true);
          console.log("ล็อคอินผ่าน LINE แล้ว");
          liff
            .getProfile()
            .then((profile) => {
              // console.log("login::>>", profile);
              if (profile.pictureUrl) {
                setLinePicture(profile.pictureUrl);
              }
              setLinename(profile.displayName);
              setLineuserId(profile.userId);
            })
            .catch((err) => console.error("Error getting profile", err));
        }
      })
      .catch((err) => {
        console.error("LIFF initialization failed", err);
      });
    if (sessionStorage.getItem("lineRegisStatus")) {
      setRegisterStutas(sessionStorage.getItem("lineRegisStatus"));
    }

    const handleUnload = () => {
      const navType = window.performance.navigation.type;
      console.log("รีโหลดดิ่ง !!", navType);
      if (navType === 1) {
        console.log("User reloaded the page");
      } else {
        console.log("User closed the page or navigated away");
        sessionStorage.removeItem("lineRegisStatus");
      }
    };

    window.addEventListener("beforeunload", handleUnload);

    return () => {
      window.removeEventListener("beforeunload", handleUnload);
    };
  }, []);

  return statusLogin ? (
    <div className="bodyform-registernotification">
      <div className="loginformpage-body">
        <form
          onSubmit={(e) => {
            e.preventDefault();
            handlecheckidpass();
          }}
        >
          <div className="loginformpage-loginbox">
            <div className="titleLine-head-registernotification">
              <img
                className="icon-profileline-registernotification"
                src={linePicture ? linePicture : ""}
                alt="profileLine"
              ></img>
              <span>{linename ? linename : ""}</span>
            </div>
            <div className="title-head-registernotification">
              <div className="icon-resNoti"></div>
              <div className="titleText-resNoti">
                <p>{"ลงทะเบียนรับการแจ้งเตือน"}</p>
                <p>{"EyeEstimate"}</p>
              </div>
            </div>
            {registerStutas ? (
              <>
                <div className="boxshowingsuccess-registernotification">
                  <div className="iconsuccess-registernotification">
                    <Icon
                      className="iconSuccessRegister"
                      icon="ep:success-filled"
                    />
                  </div>
                  <div className="textmessage-registernotification">
                    <span>{"ลงทะเบียนแจ้งเตือนสำเร็จ"}</span>
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="logindisplaygrid-box">
                  {/* <span>{"ชื่อผู้ใช้"}</span> */}
                  <div className="thisboxinput-loginform">
                    <div className="boxicon">
                      <Icon icon="bxs:user" />
                    </div>
                    <input
                      type="text"
                      id="inputlogin-username"
                      autoComplete="off"
                      placeholder={
                        isnull
                          ? !username
                            ? "กรุณากรอก ชื่อผู้ใช้งาน"
                            : ""
                          : "username"
                      }
                      onFocus={(e) => {
                        e.target.select();
                      }}
                      onChange={(e) => {
                        setUsername(e.target.value);
                      }}
                    ></input>
                  </div>
                  <span
                    className="showerror-input"
                    id="inputerrorshow-username"
                  >
                    {"กรุณาตรวจสอบชื่อผู้ใช้งาน"}
                  </span>
                </div>
                <div className="logindisplaygrid-box">
                  {/* <span>{"รหัสผ่าน"}</span> */}
                  <div className="thisboxinput-loginform">
                    <div className="boxicon">
                      <Icon icon="mdi:password" />
                    </div>
                    <input
                      id="inputlogin-password"
                      type="password"
                      onFocus={(e) => {
                        e.target.select();
                      }}
                      placeholder={
                        isnull
                          ? !password
                            ? "กรุณากรอก รหัสผ่าน"
                            : ""
                          : "password"
                      }
                      onChange={(e) => {
                        setPassword(e.target.value);
                      }}
                    ></input>
                  </div>

                  <span
                    className="showerror-input"
                    id="inputerrorshow-password"
                  >
                    {"กรุณาตรวจสอบรหัสผ่าน"}
                  </span>
                </div>
                <div className="btn-logintopin">
                  <button type="submit">{"สมัครรับแจ้งเตือน"}</button>
                </div>
                {/* <div className="btn-logintopin">
                  <button
                    type="button"
                    onClick={() => {
                      handleTestSendMessageNotify();
                    }}
                  >
                    {"ลองส่งข้อความ"}
                  </button>
                </div> */}
              </>
            )}
          </div>
        </form>
      </div>
    </div>
  ) : (
    <div className="resgiterLoading-linelogin">
      <div className="loading-box">
        <div className="just-loading-page">
          <div className="loader"></div>
          <span>{`Loading...`}</span>
        </div>
      </div>
    </div>
  );
};
export default RegisterNotification;
